import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";
import INTOUCH_API from "../../services/Api";
import useCurrentGame from "../../hooks/useCurrentGame";
import { useEffect, useState } from "react";
import General from "../../store/General";
import Game from "../../store/Game";

export default function useController() {
  const { getCurrentGame } = useCurrentGame();
  const { closeModal } = useModalActions();
  const [isGameReseting, setIsGameReseting] = useState(false);

  const resetGameProgress = async () => {
    setIsGameReseting(true);
    const gameId = getCurrentGame().id;
    await INTOUCH_API.requestManager(
      "resetGameProgress",
      { gameId },
      async (response) => {
        await General.checkAnswers(gameId);
        await Game.setMatches({
          negative: [],
          positive: [],
          neutral: [],
        });
        General.clearGameOptions();
      },
      (error) => {}
    ).finally(() => {
      setIsGameReseting(false);
      closeModal(MODAL_TYPES.RESET);
    });
  };
  useEffect(() => {
    return () => {
      setIsGameReseting(null);
    };
  });
  return {
    resetGameProgress,
    isGameReseting,
    closeModal,
  };
}
